import sendRequest from '../client/sendRequest';

const BASE_URL = '/api/blogPosts';

// Get paginated blog posts by filter, with page and limit parameters
export async function getBlogPosts({ page = 1, limit = 10, filter = {} } = {}) {
  const query = new URLSearchParams({
    page,
    limit,
    ...filter,
  }).toString();

  return await sendRequest(`${BASE_URL}?${query}`, 'GET');
}

// Get blog posts for home page
export const getHomeBlogPosts = (params) =>
  getBlogPosts({ ...params, filter: { showOnHome: true } });

// Get blog posts for blog page
export const getBlogPagePosts = (params) =>
  getBlogPosts({ ...params, filter: { showOnBlog: true } });

// Get featured blog posts for blog page
export const getFeaturedBlogPosts = (params) =>
  getBlogPosts({
    ...params,
    filter: { featured: true, showOnBlog: true },
  });

// Get all Blog posts
export async function getAllBlogPosts() {
  return await sendRequest(`${BASE_URL}/all`, 'GET');
}

// Get Blog post by slug
export async function getBlogPostBySlug(slug) {
  return await sendRequest(`${BASE_URL}/${slug}`, 'GET');
}

// Get Blog post comments by slug, with page and limit parameters
export async function getBlogPostCommentsBySlug(slug, page = 1, limit = 10) {
  return await sendRequest(
    `${BASE_URL}/${slug}/comments?page=${page}&limit=${limit}`,
    'GET',
  );
}

// Create a Blog post
export async function postBlogPost(data) {
  return await sendRequest(BASE_URL, 'POST', data);
}

// Edit a Blog post
export async function editBlogPost(id, data) {
  return await sendRequest(`${BASE_URL}/${id}`, 'PUT', data);
}

// Delete a Blog post
export async function deleteBlogPost(id) {
  return await sendRequest(`${BASE_URL}/${id}`, 'DELETE');
}
